import { render } from "./TempuraBody.vue?vue&type=template&id=143d33f5&scoped=true"
import script from "./TempuraBody.vue?vue&type=script&lang=js"
export * from "./TempuraBody.vue?vue&type=script&lang=js"

import "./TempuraBody.vue?vue&type=style&index=0&id=143d33f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143d33f5"]])

export default __exports__